// Roles del MVP. El rol "operario" fue diferido a F2 (decisión P3 — ver
// docs/analysis-prelim.md §1.3): no entra en el ENUM del MVP. Cuando F2 lo
// requiera, se agrega vía `ALTER TYPE rol_enum ADD VALUE 'operario'` + nueva
// tabla `usuarios_operarios_lineas` con contexto completo.
import { z } from 'zod';
export const roleSchema = z.enum([
    'super_admin', // Equipo Jidoka — cross-tenant
    'admin_tenant', // 1-2 por tenant — configuración estable
    'directivo', // 1-2 por tenant — estratégico multi-planta
    'coordinador', // 1-2 por planta — programación + análisis
    'supervisor', // 3 por planta (rotan T1/T2/T3) — validación por excepción
    'lider', // 15-20 por planta — captura hora a hora
    'pantalla', // 1+ por planta — TV kiosco de solo lectura (spec roles/07-pantalla.md)
]);
// Helpers de scope. NO se exportan como Set<Role> para mantener la lista
// auditable: si se agrega un rol nuevo al enum, conviene revisar a mano dónde cae.
export const ROLES_CROSS_TENANT = ['super_admin'];
export const ROLES_SCOPE_TENANT = ['admin_tenant', 'directivo'];
export const ROLES_SCOPE_PLANTA = [
    'coordinador',
    'supervisor',
    'pantalla',
];
export const ROLES_SCOPE_LINEA = ['lider'];
//# sourceMappingURL=role.js.map